import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/page_turning_left.svg'
import _imports_1 from '../assets/images/page_turning_right.svg'
import _imports_2 from '../assets/images/expire_card_del_icon.svg'
import _imports_3 from '../assets/images/special_subject_add_icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-0c5049d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "special_subject_add_bg" }
const _hoisted_2 = { class: "special_subject_info_bg" }
const _hoisted_3 = { class: "special_subject_content" }
const _hoisted_4 = { class: "special_subject_model_bg" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "special_subject_model_title" }, " 专题模板 ", -1))
const _hoisted_6 = { class: "model_list" }
const _hoisted_7 = ["onMouseenter", "onMouseleave"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "using_tips"
}
const _hoisted_11 = {
  key: 1,
  class: "model_placeHoder"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多模板敬请期待", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "model_list_bottom_view" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_16 = { class: "page_number" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_18 = { class: "card_list_bg" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card_list_title" }, "添加联卡", -1))
const _hoisted_20 = { class: "card-list" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "post-wrapper" }
const _hoisted_23 = { id: "posterHtml" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "post-link-name" }
const _hoisted_26 = { class: "custom_linkard_name" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  fit: "cover"
}, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 0,
  class: "add_linkard_edit_view"
}
const _hoisted_33 = { class: "add_linkard_info_bg" }
const _hoisted_34 = { class: "add_linkard_navi_bar" }
const _hoisted_35 = { class: "add_linkard_content" }
const _hoisted_36 = { class: "left" }
const _hoisted_37 = {
  key: 0,
  class: "selected_linkard_bg"
}
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "selected_linkard_name" }
const _hoisted_40 = { class: "right" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "linkard_title" }, "联卡链接", -1))
const _hoisted_42 = { class: "top-site-info" }
const _hoisted_43 = { class: "input-wrapper add_linkard_name_bg" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title_style" }, "联卡名称", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_BackButtonItem = _resolveComponent("BackButtonItem")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "special_subject_name_input",
        placeholder: "请输入专题名称",
        modelValue: _ctx.specialTopicInfo.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.specialTopicInfo.name) = $event)),
        maxlength: "12"
      }, null, 8, ["modelValue"]),
      _createElementVNode("button", {
        class: "back_button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.backButtonClick && _ctx.backButtonClick(...args)))
      }, "返回 "),
      _createElementVNode("button", {
        class: "submit_button",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)))
      }, "确认 ")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempModelList, (modelItem, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              onMouseenter: ($event: any) => (_ctx.handleMouseEnter(index)),
              onMouseleave: ($event: any) => (_ctx.handleMouseLeave(index)),
              style: _normalizeStyle(_ctx.itemStyle(index))
            }, [
              (!modelItem.isPlaceHoder)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(['model_item_bg', _ctx.selectedModelItem == modelItem ? 'model_item_bg_select' : '']),
                    onClick: ($event: any) => (_ctx.modelItemClick(modelItem))
                  }, [
                    _createElementVNode("img", {
                      src: modelItem.url,
                      alt: ""
                    }, null, 8, _hoisted_9),
                    (_ctx.selectedModelItem == modelItem)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, "使用中"))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_8))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
            ], 44, _hoisted_7))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_button, {
            disabled: _ctx.currentModelListPage <= 0,
            class: "page_button",
            onClick: _ctx.pageLeft
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.currentModelListPage + 1), 1),
          _createVNode(_component_el_button, {
            disabled: (_ctx.currentModelListPage + 1) * 4 >= _ctx.modelList.length,
            class: "page_button",
            onClick: _ctx.pageRight
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("ul", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specialTopicInfo.linkardList, (linkInfo, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              onClick: ($event: any) => (_ctx.subjectLinkardItemClick(linkInfo))
            }, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("img", {
                    src: linkInfo.avatar,
                    alt: "",
                    class: "post-link-logo"
                  }, null, 8, _hoisted_24),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(linkInfo.name), 1)
                ]),
                _createElementVNode("div", _hoisted_26, _toDisplayString(linkInfo.showName ? linkInfo.showName : linkInfo.name), 1),
                _createElementVNode("button", {
                  class: "handle_button delete_card_button",
                  onClick: _withModifiers(($event: any) => (_ctx.deleteButtonClick(index)), ["stop"])
                }, _hoisted_29, 8, _hoisted_27)
              ])
            ], 8, _hoisted_21))
          }), 128)),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              class: "add_button",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addLinkardButtonClick && _ctx.addLinkardButtonClick(...args)))
            }, _hoisted_31)
          ])
        ])
      ])
    ]),
    (_ctx.showAddLinkardEditView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_BackButtonItem, {
                onBackBtnClick: _ctx.closeAddLinkardEdit,
                class: "back_button"
              }, null, 8, ["onBackBtnClick"]),
              _createElementVNode("button", {
                class: "submit_button",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addLinkardSureButtonClick && _ctx.addLinkardSureButtonClick(...args)))
              }, "确认")
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                (_ctx.selectedAddLinkardItem)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createElementVNode("img", {
                        src: _ctx.selectedAddLinkardItem.avatar,
                        alt: "",
                        class: "selected_linkard_logo"
                      }, null, 8, _hoisted_38),
                      _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.selectedAddLinkardItem.name), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.baseLinkardUrl) + "/", 1),
                  _createVNode(_component_el_select, {
                    class: "el-select-option-info",
                    modelValue: _ctx.selLinkardUrl,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selLinkardUrl) = $event)),
                    placeholder: "请选择",
                    onChange: _ctx.linkardSelectedChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addLinkardList, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: index,
                          label: item.name + `(${item.url})`,
                          value: item.url
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createVNode(_component_el_input, {
                    class: "add_linkard_name",
                    modelValue: _ctx.addLinkardName,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.addLinkardName) = $event)),
                    placeholder: "请输入联卡名称"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}